/**
 * DEV-2502. Вкладка была скрыта дольше 5 минут — данные экрана и открытый чат могли
 * устареть: пришли сообщения, сменились этапы и задачи, а сокет после сна телефона
 * или ноутбука мог остаться «зомби». Возврат после долгого отсутствия — общий
 * счётчик: экраны и сокет перечитывают своё тихо, без скелета.
 */
import { ref, watch } from 'vue'

export const STALE_AFTER_MS = 5 * 60_000

const returns = ref(0)
let hiddenAt = 0
let listening = false

function onVisibilityChange() {
  if (document.visibilityState === 'hidden') {
    hiddenAt = Date.now()
    return
  }
  // Date.now, а не performance.now: во сне устройства performance.now стоит.
  if (hiddenAt && Date.now() - hiddenAt > STALE_AFTER_MS) returns.value++
  hiddenAt = 0
}

/** Вызвать в setup: reload — при возврате во вкладку после долгого отсутствия. */
export function onStaleReturn(reload: () => void) {
  if (typeof document === 'undefined') return
  if (!listening) {
    listening = true
    document.addEventListener('visibilitychange', onVisibilityChange)
  }
  watch(returns, () => reload())
}
